import { RefObject, useLayoutEffect, useState } from 'react';

/**
 * Отслеживает, превышает ли ширина наблюдаемого элемента заданный порог.
 * Состояние меняется только при пересечении порога — рендеры не происходят
 * на каждое изменение размера.
 */
export const useIsContainerWide = (ref: RefObject<HTMLElement | null>, threshold: number): boolean => {
  const [isWide, setIsWide] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const update = (width: number) => {
      const next = width >= threshold;
      setIsWide((prev) => (prev !== next ? next : prev));
    };

    update(el.getBoundingClientRect().width);

    const observer = new ResizeObserver(([entry]) => {
      update(entry.contentRect.width);
    });
    observer.observe(el);

    return () => observer.disconnect();
  }, [ref, threshold]);

  return isWide;
};
